/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Bestseller = 'Website.ProductLists.Labels.Bestseller';
export const Exclusive = 'Website.ProductLists.Labels.Exclusive';
export const InCooperationWith = 'Website.ProductLists.Labels.InCooperationWith';
export const MatasRecommend = 'Website.ProductLists.Labels.MatasRecommend';
export const RecommendationForYou = 'Website.ProductLists.Labels.RecommendationForYou';
export const Sponsored = 'Website.ProductLists.Labels.Sponsored';
export const WeRecommend = 'Website.ProductLists.Labels.WeRecommend';
